import { render } from "./vjiaoyimingxi.vue?vue&type=template&id=3a1dca2a&scoped=true"
import script from "./vjiaoyimingxi.vue?vue&type=script&lang=js"
export * from "./vjiaoyimingxi.vue?vue&type=script&lang=js"

import "./vjiaoyimingxi.vue?vue&type=style&index=0&id=3a1dca2a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1dca2a"]])

export default __exports__